import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@mui/material";
import useGlobalContext from "../../hooks/useGlobalContext";
import PageTitleSubtitle from "../../components/PageTitleSubTitle";
import PagePagination from "../../components/PagePagination";
import localize from "../../common/localize";
import TableComponent from "../../components/common/TableComponent";
import { generateNoDataValues, getFiltersInfo } from "../../common/utils";
import NoDataLabel from "../../components/common/NoDataLabel";
import ValueOrNoDataLabel from "../../components/common/ValueOrNoDataLabel";
import {
  defaultFilteringForNewness,
  getNewnessByCode,
  getNewnessFilterOptions,
} from "../../common/EntitiesManagement";
import FilterWithPrinter from "../../components/common/FilterWithPrinter";
import EntityPrinter from "../../components/common/EntityPrinter";

export default function NewnessList() {
  const {
    newnessData,
    pageIndexNewness,
    setPageIndexNewness,
    filterForNewness,
    setFilterForNewness,
    NEWNESS_ENDPOINT,
  } = useGlobalContext();

  const [newnessDataFiltered, setNewnessDataFiltered] = useState();
  const [showPrinterModal, setShowPrinterModal] = useState(false);

  useEffect(() => {
    setNewnessDataFiltered(newnessData?.Data);
  }, [newnessData]);

  const showPrinter = () => {
    setShowPrinterModal(true);
  };

  const getColumnTitles = () => {
    return [
      localize.occurr_time,
      localize.newness,
      localize.event,
      localize.reported_by,
      localize.observations,
    ];
  };

  return (
    <div className="lateral_padding">
      {showPrinterModal && (
        <EntityPrinter
          closeCallback={() => setShowPrinterModal(false)}
          title={localize.print}
          report_title={localize.newnesses}
          report_subtitle={getFiltersInfo(filterForNewness)}
          url={NEWNESS_ENDPOINT}
          filters={filterForNewness ?? []}
          columns={getColumnTitles()}
          objectTypeName="newness"
        />
      )}

      <Card
        variant="outlined"
        style={{
          margin: "16px",
          boxShadow:
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
        }}
      >
        <CardContent>
          <PageTitleSubtitle
            title={localize.reported_newness}
            subtitle={localize.reported_newness_description}
          />

          <FilterWithPrinter
            filterItemNameValue="newness_filter"
            filterDataValue={filterForNewness}
            setFilterDataValue={setFilterForNewness}
            defaultFilteringValue={defaultFilteringForNewness(true)}
            filterOptionsValue={getNewnessFilterOptions()}
            lateral_padding
            printButtonMethod={showPrinter}
          />
        </CardContent>
      </Card>

      <div style={{ marginTop: "10px" }} />
      <TableComponent
        pagination={
          <PagePagination
            pageIndex={pageIndexNewness}
            setPageIndex={setPageIndexNewness}
            dataArray={newnessData}
          />
        }
        columnTitles={getColumnTitles()}
        results={
          newnessData.Data?.length !== 0
            ? newnessDataFiltered?.map((item) => ({
                key: item.Id,
                data: [
                  new Date(item.OccurrTime).toLocaleDateString(undefined, {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  }),
                  item.AdditionalNewness?.Name ?? getNewnessByCode(item.Code),
                  item.Event ? (
                    <Link
                      to={`/events/detail/${item.Event.Id}`}
                      style={{ color: "#21469C" }}
                    >
                      {item.Event.Code}
                    </Link>
                  ) : (
                    <NoDataLabel text={localize.no_data} />
                  ),
                  item.CreatedBy,
                  <ValueOrNoDataLabel data={item?.Observation} />,
                ],
              }))
            : [generateNoDataValues(5)]
        }
      />
    </div>
  );
}
